import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField, } from '../../../../../components';
import { Button, Container, Dialog, Grid, Paper, Stack, Typography, TextField as MuiTextField, Box, Radio, IconButton, } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dateFormatter, dropdownFetch, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { GENDER_DROPDOWN, PATIENT_TYPES } from '../../../../../constants/dropdown';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { AddSurgeryDetailsForm } from './AddSurgeryDetailsForm';
import { AddResourcesDetailsForm } from './AddResourcesDetailsForm';

const initialPatientDataObj = {
  data: [],
  loading: false
};

const initialOtDataObj = {
  data: [],
  loading: false
};

const initialOpdDataObj = {
  data: [],
  loading: false
};

const TABLE_HEADER = [
  { header: 'Uhid', accessor: (row) => row?.uhid },
  { header: 'Patient Name', accessor: (row) => `${row.patient?.name}` },
  { header: 'Mobile No', accessor: (row) => row?.patient?.mobile_no },
  { header: 'Address', accessor: (row) => row?.patient?.address },
  { header: 'Date', accessor: (row) => dateFormatter(row?.createdAt) },
]
const OPD_PATIENT_TABLE_COLUMNS = [
  { header: 'Uhid', accessor: (row) => row?.uhid },
  { header: 'Patient Name', accessor: (row) => `${row.name_suffix} ${row.first_name} ${row.last_name} ` },
  { header: 'Mobile No', accessor: (row) => row?.address?.mobile },
  { header: 'Doctor', accessor: (row) => row?.consultant?.name },
  { header: 'Sponsor', accessor: (row) => row?.sponsor?.name },
  { header: 'Address', accessor: (row) => row?.address?.address },
  { header: 'Date', accessor: (row) => dateFormatter(row?.createdAt) },
];

const IPD_TABLE_COLUMNS = [
  { header: 'Ipd No', accessor: (row) => row?.ipd_no },
  { header: 'Patient Name', accessor: (row) => row?.patient?.name },
  { header: 'Mobile No', accessor: (row) => row?.patient?.mobile },
  { header: 'Doctor', accessor: (row) => row?.consultant_detail?.doctor?.name },
  { header: 'Address', accessor: (row) => row?.patient?.address },
  { header: 'Date', accessor: (row) => dateFormatter(row?.createdAt) },
];

export const OTSchedule = () => {
  const doctorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
  const [otScheduleDataObj, setOtScheduleDataObj] = useState(initialOtDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [ipdPatientDetail, setIpdPatientDetail] = useState([])
  const [opdData, setOpdData] = useState(initialOpdDataObj)
  const [ipdData, setIpdData] = useState([])
  const [opdInput, setOpdInput] = useState('')
  const [ipdInput, setIpdInput] = useState('')
  const [posData, setPosData] = useState([])
  const [opdFilterData, setOpdFilterData] = useState([]);
  const [ipdFilterData, setIpdFilterData] = useState([]);
  const productRef = useRef()
  const [productStock, setProductStock] = useState([])
  const [doctorDropdown, setDoctorDropdown] = useState([])
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [wardDropdown, setWardDropdown] = useState([])
  const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
  const [warehouse, setWareHouse] = useState([])
  const [medicinesDetails, setMedicineDetails] = useState([])
  const [labDetails, setLabDetails] = useState([])
  const [serviceDetails, setServiceDetails] = useState([])
  const [stateName, setStateName] = useState([]);
  const [cityName, setCityName] = useState([]);
  const [ipdRegistrationOpenDialogue, setIpdRegisterationOpenDialogue] = useState(false)
  const [opdRegistrationOpenDialogue, setOpdRegistrationOpenDialogue] = useState(false)
  const [operationTheatreDropdown, setOperationTheatreDropdown] = useState(false)
  const [addSurgeryDialogOpen, setAddSurgeryDialogOpen] = useState(false)
  const [addResourcesDialogOpen, setAddResourcesDialogOpen] = useState(false)
  const [serviceDropdown, setSeriveDropdown] = useState([]);
  const [regionDropdown, setRegionDropdown] = useState([]);
  const [resourceDetailList, setResourceDetailList] = useState([]);
  const [inputOt, setInputOt] = useState('')
  const [filteredOtData, setFilteredOtData] = useState([])
  const [equipmentDropdown,setEquipmentDropdown] = useState([])



  const user = JSON.parse(localStorage.getItem('user'));

  const { getValues } = useForm()
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        // location_to: Yup.string().required(' '),
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const getOperationTheatreDropdown = useCallback(async () => {
    const data = await dropdownFetch('operation-theatre');
    setOperationTheatreDropdown(data);
  }, []);

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor-surgeon');
    const filteredData = data.filter(
      (item) => item.other_details?.ot_doctor === "Yes"
    );
    if (!selectedRecord && !getValues('doctor')) {
      const [defaultState] = filteredData.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details?.department);
      }
    }
    setDoctorDropdown(filteredData);
  }, [selectedRecord, getValues, setValue]);

  const getWardDropdown = useCallback(async () => {
    const data = await dropdownFetch('ward');
    setWardDropdown(data);
  }, []);

  const getRoomMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('room-master');
    setRoomMasterDropdown(data);
  }, []);


  const getWareHouseDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    setWareHouse(data);
  }, []);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('sponsor', defaultSponsor?._id);
    }
    setSponsorDropdown(data);
  }, []);

  const getStateDropdown = useCallback(async () => {
    const data = await dropdownFetch('state');
    setStateName(data);
  }, []);

  const getCityDropdown = useCallback(async () => {
    const data = await dropdownFetch('city');
    setCityName(data);
  }, []);

  const getServiceDropdown = useCallback(async () => {
    const data = await dropdownFetch('service')
    const filteredData = data.filter((item) => item.type === "SR")
    setSeriveDropdown(filteredData);
  }, []);


  const getRegionDropdown = useCallback(async () => {
    const data = await dropdownFetch('region-master');
    setRegionDropdown(data);
  }, []);

  const getEquipmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('equipment-master');
    setEquipmentDropdown(data);
  }, []);

  useEffect(() => {
    getDoctorDropdown()
    getSponsorDropdown()
    getWardDropdown()
    getRoomMasterDropdown()
    getWareHouseDropdown()
    getStateDropdown()
    getCityDropdown()
    getOperationTheatreDropdown()
    getServiceDropdown()
    getRegionDropdown()
    getEquipmentDropdown()
  }, [
    getDoctorDropdown,
    getSponsorDropdown,
    getWardDropdown,
    getRoomMasterDropdown,
    getWareHouseDropdown,
    getCityDropdown,
    getOperationTheatreDropdown,
    getStateDropdown,
    getServiceDropdown,
    getRegionDropdown,
    getEquipmentDropdown
  ])



  const formSubmit = async (formValues) => {
    if (detailList.length === 0) {
      toast('Please add the surgery first', { variant: 'warning' });
      return;
    }
    if (resourceDetailList.length === 0) {
      toast('Please add the Resources First', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const payload = {
      ...formValues,
      uhid: formValues.uhid,
      ipd_no: formValues.ipd_no,
      ...formValues.bill,
      surgery_items: detailList,
      resource_detail: resourceDetailList
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/ot-schedule-edit' : '/ot-schedule-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} OT Schedule`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      setDetailList([])
      reset()
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} OT Schedule`, { variant: 'error' });
    }
    setLoading(false);
  };


  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setOtScheduleDataObj({ loading: true });
    const response = await request('/ot-schedule-list', { method: 'GET',query: {limit:10} });
    if (response.success) {
      const filteredData = response.data.filter(item =>
        item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOtScheduleDataObj({ loading: false, data: filteredData });
      setPosData({ loading: false, data: response.data })
    } else {
      toast('Failed to load Retail Sale list', { variant: 'error' });
      setOtScheduleDataObj({ loading: false });
    }
  };

  const handleRowDelete = (row) => {
    setDetailList((prev) => prev.filter((data) => data.surgery !== row));
  };


  const handledeleteResource = (row) => {
    setResourceDetailList((prev) => prev.filter((data) => data.doctor !== row));
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/ot-schedule-cancel',{
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel the Ot Schedule', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel the Ot Schedule', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/ot-schedule-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Ot Schedule', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Ot Schedule', { variant: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (productStock && productStock.length > 0) {
      setOriginalData(productStock);
      setIsFiltered(false);
    }
  }, [productStock]);

  
  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleOpdPatient = (row) => {
    setValue('patient_name', `${row?.name_suffix}${row?.first_name}${row?.last_name} `)
    setValue('gender', row?.gender)
    setValue('age', calculateAge(row?.dob))
    setValue('country', row?.address?.country)
    setValue('state', row?.address?.state._id)
    setValue('city', row?.address?.city)
    setValue('mobile', row?.address?.mobile)
    setValue('uhid', row?.uhid)
    setOpdRegistrationOpenDialogue(false)
  }

  const handleIpdRow = (row) => {
    setValue("patient_name", row?.patient?.name)
    setValue("gender", row?.patient?.gender)
    setValue("age", calculateAge(row?.patient?.dob))
    setValue("country", (row?.patient?.country))
    setValue("state", (row?.patient?.state))
    setValue("rel_name", (row?.care_taker?.name_1))
    setValue("rel_mobile_no", (row?.care_taker?.mobile_1))
    setValue("bed_no", (row?.consultant_detail?.bed_no))
    setValue("ward", (row?.consultant_detail?.room?.ward?._id))
    setValue("room", (row?.consultant_detail?.room?._id))
    setValue("doctor", (row?.consultant_detail?.doctor?._id))
    setValue("city", (row?.patient?.city))
    setValue("mobile", (row?.patient?.mobile))
    setValue('uhid', row?.uhid)
    setValue('ipd_no', row?.ipd_no)
    setIpdPatientDetail(row)
    setIpdRegisterationOpenDialogue(false)
  }



  const ITEM_DETAIL_HEADER = [
    {
      header: 'Region',
      accessor: (row) => row.regionName
    },
    {
      header: 'Surgery Name',
      accessor: (row) => row.surgeryName
    },
    {
      header: 'Start Time',
      accessor: 'sch_time'
    },
    {
      header: 'Duration',
      accessor: 'duration'
    },
    {
      header: 'Surgery Type',
      accessor: 'surgery_type'
    },
  ];

  const RESOURCE_HEADER = [
    {
      header: 'Resource Type', accessor: "type",
    },
    {
      header: 'Particular', 
      accessor: row => row.equipmentName || row.doctorName, 
    },
  ];

  useEffect(() => {
    if (Array.isArray(opdData.data) && opdData.data.length > 0) {
      setOpdFilterData(opdData.data); 
      setIsFiltered(false);
    }
  }, [opdData.data]);

  useEffect(() => {
    handleOpdDataFilter(opdInput);
  }, [opdInput]);

  const handleOpdDataFilter = (input) => {
    if (!input) {
      setOpdFilterData(opdData.data); 
      return;
    }

    const lowercasedInput = input.toLowerCase();
    const filtered = opdData?.data?.filter(
      (item) =>
        item?.uhid?.toString().toLowerCase().includes(lowercasedInput) ||
        item?.patient?.name?.toLowerCase().includes(lowercasedInput)
    ) || []; 
    setOpdFilterData(filtered);
  };

  useEffect(() => {
    if (
      indoorRegisterationDataObj.data &&
      Array.isArray(indoorRegisterationDataObj.data) &&
      indoorRegisterationDataObj.data.length > 0
    ) {
      setIpdFilterData(indoorRegisterationDataObj.data);
      setIsFiltered(false);
    }
  }, [indoorRegisterationDataObj.data]);

  useEffect(() => {
    handleIpdDataFilter(ipdInput); 
  }, [ipdInput]);

  const handleIpdDataFilter = (input) => {
    const lowercasedInput = input.toLowerCase();
    const filtered = indoorRegisterationDataObj.data.filter(
      (item) =>
        item?.ipd_no?.toString().toLowerCase().includes(lowercasedInput) ||
        item?.patient?.name?.toLowerCase().includes(lowercasedInput)
    );
    setIpdFilterData(filtered); // Set filtered array
  };


  useEffect(() => {
    if (otScheduleDataObj.data && otScheduleDataObj.data.length > 0) {
      setFilteredOtData(otScheduleDataObj.data);
      setIsFiltered(false);
    }
  }, [otScheduleDataObj.data]);

  useEffect(() => {
    handleOtSearch(inputOt);
  }, [inputOt]);

  const handleOtSearch = () => {
    const lowercasedInput = inputOt.toLowerCase();
    const filtered = otScheduleDataObj.data.filter((item) =>
      item?.uhid?.toString().toLowerCase().includes(lowercasedInput) ||
      item?.patient?.name?.toString().toLowerCase().includes(lowercasedInput)
    );
    setFilteredOtData(filtered);
  };

  const fetchOpdPatients = async () => {
    setOpdRegistrationOpenDialogue(true);
    setPatientDataObj({ loading: true });
    try {
      const response = await request('/patient-registeration-list', { method: 'GET' });
      if (response.success) {
        setPatientDataObj({ loading: false, data: response?.patientData});
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    } catch (error) {
      console.error('Error fetching patient data:', error);
      toast('Error in fetching data', { variant: 'error' });
      setPatientDataObj({ loading: false });
    }
  };

  const fetchIpdPatient = async () => {
    setIpdRegisterationOpenDialogue(true);
    setIndoorRegisterationDataObj({ loading: true });
    const response = await request('/indoor-registeration-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(item => item.admission_status === "admit");
      setIndoorRegisterationDataObj({ loading: false, data: filteredData });
      setIpdData(sortedData)
      setIpdFilterData({ data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };



  useEffect(() => {
    handleIpdSearch(input);
  }, [ipdInput]);

  const handleIpdSearch = async () => {
    const lowercasedInput = ipdInput.toLowerCase().trim();
      try {
        const response = await request('/indoor-registeration-list', {
          method: 'GET',
          query: { name: lowercasedInput,limit:10}
        });
        if (response.success && Array.isArray(response.data)) {
          setIndoorRegisterationDataObj({ loading: false, data: response.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setIndoorRegisterationDataObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setIndoorRegisterationDataObj({ loading: false, data: [] });
      }
  };

  const handleIpdChanges= (e) => {
    const newInput = e.target.value;
    setIpdInput(newInput);
  };

  useEffect(() => {
    handleOpdSearch(input);
  }, [opdInput]);

  const handleOpdSearch = async () => {
    const lowercasedInput = opdInput.toLowerCase().trim();
      try {
        const response = await request('/patient-registeration-list', {
          method: 'GET',
          query: { name: lowercasedInput,limit:10}
        });
        if (response.success) {
          setPatientDataObj({ loading: false, data: response?.patientData });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setPatientDataObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setPatientDataObj({ loading: false, data: [] });
      }
  };

  const handleOpdChanges= (e) => {
    const newInput = e.target.value;
    setOpdInput(newInput);
  }

  const opdIpdWatch = watch('booking_mode')

  const onDetailAddHandler = (data) => {
    const existingDetail = detailList.find(({ surgery }) => surgery === data.surgery);
    if (existingDetail) {
      toast('Surgery already chosen', { variant: 'error' });
      return;
    }else{
      toast('Surgery Choosen Successfully', { variant: 'success' });
    }
    const surgeryName = serviceDropdown.find(({ _id }) => _id === data.surgery)?.service_name;
    const RegionName = regionDropdown.find(({ _id }) => _id === data.region)?.region;
    setDetailList((prev) => [
      ...prev,
      {
        ...data,
        surgery: data.surgery,
        surgeryName: surgeryName,
        region: data.region,
        regionName: RegionName
      }
    ]);
  };

  const onAddAddResourcehandler = (data) => {
    const existingDetail = resourceDetailList.find(({ doctor }) => doctor === data.doctor);
    if (existingDetail) {
      toast('Doctor already chosen', { variant: 'error' });
      return;
    } else {
      toast('Resources Added Successfully', { variant: 'success' });
    }
    const doctorName = doctorDropdown.find(({ _id }) => _id === data.doctor)?.name;
    const equipmentName = equipmentDropdown.find(({ _id }) => _id === data?.equipment)?.equipment;
    let resourceData = {
      ...data,
      doctorName: doctorName,
      equipmentName: equipmentName,
    };
    if (data.doctor && data.equipment) {
      delete resourceData.equipment;
    } else if (data.equipment) {
      delete resourceData.doctor;
      delete resourceData.doctorName; 
    } else if (data.doctor) {
      delete resourceData.equipment;
      delete resourceData.equipmentName
    }
    setResourceDetailList((prev) => [
      ...prev,
      resourceData,
    ]);
  };
  

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'surgery_items',
        'patient',
        'ipdpatient',
        'resource_detail',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      const formattedbillDate = selectedRecord?.date
        ? new Date(selectedRecord.date).toISOString().split('T')[0]
        : '';
      setValue("patient_name", selectedRecord?.patient?.name)
      setValue("gender", selectedRecord?.patient?.gender)
      setValue("age", calculateAge(selectedRecord?.patient?.dob))
      setValue("country", (selectedRecord?.patient?.country))
      setValue("mobile", (selectedRecord?.patient?.mobile))
      setValue("state", (selectedRecord?.patient?.state))
      setValue("rel_mobile_no", (selectedRecord?.ipdpatient?.care_taker?.mobile_1))
      setValue("bed_no", (selectedRecord?.ipdpatient?.consultant_detail?.bed_no))
      setValue("ward", (selectedRecord?.consultant_detail?.room?.ward?._id))
      setValue("room", (selectedRecord?.ipdpatient?.consultant_detail?.room))
      setValue("doctor", (selectedRecord?.consultant_detail?.doctor?._id))
      setValue("city", (selectedRecord?.patient?.city))
      setValue("mobile", (selectedRecord?.patient?.mobile_no))
      setValue("age", calculateAge(selectedRecord?.patient?.dob))
      setValue("schedule_no", (selectedRecord?.schedule_no))
      setValue('uhid', selectedRecord?.uhid)
      setValue('ipd_no', selectedRecord?.ipd_no)
      setValue('optheatre', selectedRecord?.optheatre)
      setValue('doctor', selectedRecord?.doctor)
      setValue('remarks', selectedRecord?.remarks)
      setValue('ward', selectedRecord?.roomDetails?.[0]?.ward)
      setValue('rel_name', selectedRecord?.ipdpatient?.care_taker?.name_1)
      setValue('booking_mode', selectedRecord?.booking_mode)
      setDetailList(selectedRecord.surgery_items);
      setResourceDetailList(selectedRecord?.resource_detail)
    } else {
      reset();
    }
  }, [selectedRecord]);




  useEffect(() => {
    handleSearch(input);
  }, [inputOt]);

  const handleSearch = async () => {
    const lowercasedInput = inputOt.toLowerCase().trim();
      try {
        const response = await request('/ot-schedule-list', {
          method: 'GET',
          query: { name: lowercasedInput ,limit:10}
        });
        if (response.success && Array.isArray(response.data)) {
          setOtScheduleDataObj({ loading: false, data: response.data });
        } else {
          toast('Error in fetching data', { variant: 'error' });
          setOtScheduleDataObj({ loading: false, data: [] });
        }
      } catch (error) {
        console.error('Error during search:', error);
        toast('Error during search', { variant: 'error' });
        setOtScheduleDataObj({ loading: false, data: [] });
      }
  
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInputOt(newInput);
  };

  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)} >
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Operation Theatre Schedule
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([])
                    setMedicineDetails([])
                    setServiceDetails([])
                    setLabDetails([])
                    reset()
                    setResourceDetailList([])
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={"Submit"}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={"Cancel"}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord()
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                  onClick={handleQueryWindow}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn id={"Exit"} variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >Exit</CustomButtonn>
              </Stack>
            </Stack>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '100%', boxShadow: '0px 2px 10px #0099ff' }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                  <Stack sx={{ border: "0px solid grey", padding: "5px", borderRadius: "5px", boxShadow: '0px 2px 2px #0099ff' }} spacing={0.5} direction="row">
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '2rem', fontSize: '1.4rem', }}>Schedule No./ Date</Typography>
                        <TextField
                          disabled
                          sx={{ flex: 0.4 }}
                          name="schedule_no"
                        />
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.4, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                          name="date"
                          type="date"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem',  fontSize: '1.4rem',}}>Patient Name</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8 }}
                          name="patient_name"
                          placeholder="Enter Patient Name"

                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem',}}>City/Mobile</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.4 }}
                          name="city"
                          menus={cityName.map((data) => ({ ...data, name: data.city }))}
                        />
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.4 }}
                          name="mobile"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem',  fontSize: '1.4rem', }}>Prescribed Doctor</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8 }}
                          name="doctor"
                          placeholder="Prescribed Doctor"
                          menus={doctorDropdown.map((data) => ({ ...data, name: data.name }))}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem',  fontSize: '1.4rem', }}>Booking Mode</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.5, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                          name="booking_mode"
                          placeholder="Booking Mode"
                          menus={PATIENT_TYPES}
                        />
                        <TextField
                          disabled
                          sx={{ flex: 0.2, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                          name="bookingMode"
                        />
                        <Button
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                          variant="contained"
                          onClick={() => {
                            if (opdIpdWatch === "OPD") {
                              fetchOpdPatients();
                            }
                            if (opdIpdWatch === "IPD") {
                              fetchIpdPatient();
                            }
                          }}
                        >
                          <SearchIcon />
                        </Button>
                      </Stack>

                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem',  fontSize: '1.4rem', }}>Gender/Age</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.4 }}
                          name="gender"
                          placeholder="Select Gender"
                          menus={GENDER_DROPDOWN}
                        />
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.4 }}
                          name="age"
                          placeholder="Age"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem',  fontSize: '1.4rem', }}>Rel.Name/MobileNo.</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.4 }}
                          name="rel_name"
                          placeholder="Care Taker Name"
                        />
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.4 }}
                          name="rel_mobile_no"
                          placeholder="Care Taker Number"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem',  fontSize: '1.4rem', }}>OP Theatre</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.8 }}
                          name="optheatre"
                          placeholder="Select Operation Theatre"
                          menus={(operationTheatreDropdown || []).map((data) => ({
                            ...data,
                            name: data.operationtheatre || '',
                          }))}
                        />
                      </Stack>
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700,  fontSize: '1.4rem', }}>ipd/Uhid/Date</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.2, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                          name="ipd_no"
                        />
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.2, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                          name="uhid"
                        />
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.4, border: currentAction ? "0.5px solid red" : "", backgroundColor: currentAction ? '#B3E5FC' : "" }}
                          name="date"
                          type="date"
                        />

                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700,  fontSize: '1.4rem', }}>Country/State</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.4 }}
                          name="country"
                          menus={[{ _id: 'IN', name: 'India' }]}
                          placeholder="Select Country"
                        />
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.4 }}
                          name="state"
                          menus={stateName.map((data) => ({ ...data, name: data.state }))}
                          placeholder="State"
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700,  fontSize: '1.4rem', }}>Ward/Room/Bed</Typography>
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.3 }}
                          name="ward"
                          menus={wardDropdown.map((data) => ({ ...data, name: data.name }))}
                          placeholder="Select Ward"
                        />
                        <SelectTag
                          disabled={!['new', 'edit'].includes(currentAction)}
                          formControlSX={{ flex: 0.3 }}
                          name="room"
                          menus={roomMasterDropdown.map((data) => ({ ...data, name: data.room_no }))}
                          placeholder="Select Room"
                        />
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.2 }}
                          name="bed_no"
                          placeholder="Bed No."
                        />
                      </Stack>
                      <Stack spacing={0.5} direction="row" alignItems="center">
                        <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem',  fontSize: '1.4rem', }}>Remarks</Typography>
                        <TextField
                          disabled={!['new', 'edit'].includes(currentAction)}
                          sx={{ flex: 0.8 }}
                          name="remarks"
                          placeholder="Remarks"

                        />
                      </Stack>
                    </Grid>
                  </Stack>
                  <Typography onClick={() => {
                    !['new', 'edit'].includes(currentAction) ||
                    setAddSurgeryDialogOpen(true)
                  }} sx={{ fontWeight: 700, fontSize: '1.4rem', color: !['new', 'edit'].includes(currentAction) ? "grey" : "blue", cursor: "pointer" }}>Add Surgery</Typography>
                  <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3 }}>
                    <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'row', boxShadow: '0px 2px 2px #0099ff'}}>
                      <Table
                        containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                        data={detailList && detailList.map((data) => ({ _id: data.surgery, ...data })) || []}
                        columns={ITEM_DETAIL_HEADER}
                        size="small"
                        showDeleteAction={true}
                        onDeleteHandler={(row) => handleRowDelete(row)}
                      />
                    </Grid>
                    <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column',boxShadow: '0px 2px 2px #0099ff' }}>
                      <Typography
                        onClick={() => {
                          !['new', 'edit'].includes(currentAction) ||
                          setAddResourcesDialogOpen(true)
                        }}
                        sx={{ fontWeight: 700, fontSize: '1.4rem',color: !['new', 'edit'].includes(currentAction) ? "grey" : "blue",cursor: "pointer" }}>
                        Add Resources
                      </Typography>
                      <Table
                        containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                        data={resourceDetailList && resourceDetailList.map((data) => ({ _id: data.doctor, ...data })) || []}
                        columns={RESOURCE_HEADER}
                        size="small"
                        showDeleteAction={true}
                        onDeleteHandler={handledeleteResource}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container >
      </Paper >
      <Dialog
        open={opdRegistrationOpenDialogue}
        onClose={() => setOpdRegistrationOpenDialogue(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Opd Patient Details
          </Typography>
          <IconButton onClick={() => setOpdRegistrationOpenDialogue(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
              },
              '& .MuiOutlinedInput-input': {
                padding: '12px 14px',
              },
            }}
            label="Search Patient By Name"
            variant="outlined"
            value={opdInput}
            onChange={handleOpdChanges}
          />

        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={OPD_PATIENT_TABLE_COLUMNS}
          data={patientDataObj?.data || []}
          loading={opdData.loading}
          onRowClick={(row) => {
            handleOpdPatient(row);
          }}
        />
      </Dialog>
      <Dialog
        open={ipdRegistrationOpenDialogue}
        onClose={() => setIpdRegisterationOpenDialogue(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            IPD Patient Details
          </Typography>
          <IconButton onClick={() => setIpdRegisterationOpenDialogue(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' 
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' 
              }
            }}
            label="Search Patient By IPD No."
            variant="outlined"
            value={ipdInput}
            onChange={handleIpdChanges}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={IPD_TABLE_COLUMNS}
          data={indoorRegisterationDataObj?.data || []} 
          loading={indoorRegisterationDataObj.loading}
          onRowClick={(row) => {
            handleIpdRow(row);
          }}
        />;
      </Dialog>
      <Dialog
        open={addSurgeryDialogOpen}
        onClose={() => setAddSurgeryDialogOpen(false)}
        PaperProps={{ sx: { width: '60%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <AddSurgeryDetailsForm
          doctorID={doctorIDRef.current}
          onClose={() => setAddSurgeryDialogOpen(false)}
          onAdd={onDetailAddHandler}
          serviceDropdown={serviceDropdown}
          regionDropdown={regionDropdown}
        />
      </Dialog>
      <Dialog
        open={addResourcesDialogOpen}
        onClose={() => setAddResourcesDialogOpen(false)}
        PaperProps={{ sx: { width: '60%', height: '70vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <AddResourcesDetailsForm
          doctorID={doctorIDRef.current}
          onClose={() => setAddResourcesDialogOpen(false)}
          onAdd={onAddAddResourcehandler}
          doctorDropdown={doctorDropdown}
          equipmentDropdown={equipmentDropdown}
          setDoctorDropdown={setDoctorDropdown}
        />
      </Dialog>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            OT Schedule Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' 
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' 
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={inputOt}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 1 }}
          columns={TABLE_HEADER}
          data={otScheduleDataObj?.data || []}
          loading={otScheduleDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
